module.exports = __webpack_public_path__ + "img/avatar0.2319184f.png";